import { Checkbox } from "PFComponents/checkbox";
import { Stack } from "PFComponents/containers";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { UploadPage } from "../import_modal";

enum ImportSettingsKey {
  SendWelcomeEmails = "notify",
  ForceActiveRegistrationStatus = "force_active_registration_status"
}

type ImportSettingsProps = {
  onSuccess: () => void;
};

export const UsersUploadPage = ({ onSuccess }: ImportSettingsProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "importProfiles.settings" });

  const [importSettings, setImportSettings] = useState<Record<ImportSettingsKey, boolean>>({
    [ImportSettingsKey.SendWelcomeEmails]: false,
    [ImportSettingsKey.ForceActiveRegistrationStatus]: false
  });

  const handleChange = (key: ImportSettingsKey, value: boolean) => {
    const newSettings = { ...importSettings, [key]: value };
    setImportSettings(newSettings);
  };

  return (
    <Stack grow={1}>
      <Stack>
        <Checkbox
          label={t("sendWelcomeEmails")}
          checked={importSettings[ImportSettingsKey.SendWelcomeEmails]}
          onChange={(value: boolean) => handleChange(ImportSettingsKey.SendWelcomeEmails, value)}
        />
        <Checkbox
          label={t("forceActiveRegistrationStatus")}
          checked={importSettings[ImportSettingsKey.ForceActiveRegistrationStatus]}
          onChange={(value: boolean) => handleChange(ImportSettingsKey.ForceActiveRegistrationStatus, value)}
        />
      </Stack>
      <UploadPage data={{ options: importSettings }} url="/users/imports" onSuccess={onSuccess} />
    </Stack>
  );
};
